import App from './App.svelte';

import { mount } from 'svelte';

const feedbackForm = document.querySelector('#feedback-form');

if (feedbackForm) {
  const app = mount(App, {
    target: feedbackForm,
  });
}

export default app;
